// Harborhearth – Scroll Fade-In Animations
(function () {
  var style = document.createElement('style');
    style.textContent = [
        '.hh-fade{opacity:0;transform:translateY(28px);transition:opacity .65s ease,transform .65s ease}',
            '.hh-fade.hh-visible{opacity:1;transform:translateY(0)}'
              ].join('');
                document.head.appendChild(style);

                  var selectors = [
                      '.shopify-section:not(:first-child)',
                          '.featured-collection__title',
                              '.image-with-text__content'
                                ].join(',');

                                  var els = document.querySelectorAll(selectors);

                                    if (!('IntersectionObserver' in window)) {
                                        els.forEach(function(el){ el.classList.add('hh-visible'); });
                                            return;
                                              }

                                                var obs = new IntersectionObserver(function(entries) {
                                                    entries.forEach(function(entry) {
                                                          if (entry.isIntersecting) {
                                                                  entry.target.classList.add('hh-visible');
                                                                          obs.unobserve(entry.target);
                                                                                }
                                                                                    });
                                                                                      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

                                                                                        els.forEach(function(el) {
                                                                                            el.classList.add('hh-fade');
                                                                                                obs.observe(el);
                                                                                                  });
                                                                                                  })();